<template>
    <div class="row">
        <div class="col">
            <entities-crud></entities-crud>
        </div>
    </div>
</template>

<script>
    import EntitiesCrud from './entities/EntitiesCrud';

    export default {
        components: {
            EntitiesCrud
        }
    }
</script>
